import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { notifyError, notifySuccess } from "../utils/Toastify";
import { useAuth } from "../contexts/AuthContext";

const AuthLogin: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { autoLogin } = useAuth();

  useEffect(() => {
    const verifyToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      const source_app = urlParams.get("source_app");
      const target_app = urlParams.get("target_app");

      if (!token) {
        notifyError("No token found. Please log in again.");
        navigate("/login", { replace: true });
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);

        let API_URL;
        if (source_app === "APP") {
          API_URL = "https://apicrm.microagent.services/auth/exchange";
        } else if (source_app === "CRM") {
          API_URL = "https://apichatbot.microagent.services/api/auth/exchange";
        }

        const response = await fetch(API_URL as string, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: token,
            source_app: source_app || "CHATBOT",
            target_app: target_app || "CHATBOT",
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // Handle token returned from backend
        const verifiedToken =
          data?.access_token || data?.token || data?.data?.access_token;

        const user = data.user;

        if (!verifiedToken) {
          throw new Error("No valid token returned from server.");
        }

        // Save verified token to local storage
        localStorage.setItem("token", verifiedToken);
        localStorage.setItem("accessToken", verifiedToken);
        await autoLogin({ user, verifiedToken });

        navigate("/dashboard", { replace: true });

        // Clean URL
        window.history.replaceState({}, "", "/autologin");

        // notifySuccess("Authentication successful!");
      } catch (error) {
        localStorage.removeItem("token");
        // notifyError("Authentication failed. Please log in again.");
        navigate("/login", { replace: true });
      } finally {
        setIsLoading(false);
      }
    };

    verifyToken();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-dashboard-bg text-white">
        <Loader2 className="animate-spin text-dashboard-purple w-12 h-12 mb-4" />
        <p className="text-lg font-medium">Verifying your credentials...</p>
      </div>
    );
  }

  return null;
};

export default AuthLogin;
